import { IPollingSetup } from '@/features/polling-setup/pollingSetupSlice'
import { IPollingSetupProps } from '@/pages/Settings/PollingSetup/compoments/EditForm'
import IApiResponse from '@/types/api-response'
import axios from '@/utils/axios-instance'

export const getPollingSetups = async (): Promise<
	IApiResponse<IPollingSetup[]>
> => {
	const { data } = await axios.get<IApiResponse<IPollingSetup[]>>(
		'/api/polling-setup'
	)
	return data
}

export const updatePollingSetups = async (
	setups: IPollingSetupProps[]
): Promise<IApiResponse<null>> => {
	const { data } = await axios.post<IApiResponse<null>>(
		'/api/polling-setup',
		setups.map((x) => ({
			description: x.description,
			max_remaining: x.max_remaining,
			min_remaining: x.min_remaining,
			polling_interval: x.polling_interval,
		}))
	)
	return data
}
